import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const comparisonItems = [
    { featureKey: 'comparison.turnkey', aligcus: true, traditional: false },
    { featureKey: 'comparison.preApproved', aligcus: true, traditional: false },
    { featureKey: 'comparison.expedited', aligcus: true, traditional: false },
    { featureKey: 'comparison.permittingTeam', aligcus: true, traditional: false },
    { featureKey: 'comparison.floorPlans', aligcus: true, traditional: false },
    { featureKey: 'comparison.inspection', aligcus: true, traditional: false },
    { featureKey: 'comparison.projectManager', aligcus: true, traditional: false },
    { featureKey: 'comparison.timeOnSite', aligcus: 'comparison.aligcusTime', traditional: 'comparison.traditionalTime' },
    { featureKey: 'comparison.pricing', aligcus: true, traditional: false },
    { featureKey: 'comparison.financing', aligcus: true, traditional: false }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">{t('comparison.title')}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">{t('comparison.subtitle')}</p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border border-gray-100">
          <div className="grid grid-cols-[50%_25%_25%] bg-gradient-to-r from-red-600 to-red-700 text-white">
            <div className="p-4 font-bold text-xl">{t('comparison.feature')}</div>
            <div className="p-4 font-bold text-lg text-center border-x border-red-500">{t('comparison.aligcus')}</div>
            <div className="p-4 font-bold text-lg text-center">{t('comparison.traditional')}</div>
          </div>

          {comparisonItems.map((item, index) => (
            <div key={index} className={`grid grid-cols-[50%_25%_25%] ${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} hover:bg-red-50 transition-colors duration-200`}>
              <div className="px-4 py-2.5 font-medium text-gray-900 text-lg">{t(item.featureKey)}</div>
              <div className="px-4 py-2.5 border-x border-gray-200 flex items-center justify-center">
                {typeof item.aligcus === 'boolean' ? (
                  <div className="w-6 h-6 bg-green-500 rounded-full flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                ) : (
                  <span className="font-semibold text-red-600 text-sm">{t(item.aligcus)}</span>
                )}
              </div>
              <div className="px-4 py-2.5 flex items-center justify-center">
                {typeof item.traditional === 'boolean' ? (
                  <div className="w-6 h-6 bg-gray-400 rounded-full flex items-center justify-center">
                    <X className="w-4 h-4 text-white" />
                  </div>
                ) : (
                  <span className="font-medium text-gray-600 text-sm">{t(item.traditional)}</span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xl text-gray-700 mb-6">{t('comparison.experience')}</p>
          <button className="bg-red-600 hover:bg-red-700 text-white font-semibold px-10 py-4 text-lg rounded-lg transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105" onClick={() => navigate('/quote')}>
            {t('comparison.cta')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
